import { Alert, Card, Col, Row } from "react-bootstrap";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import ReactFancyBox from "react-fancybox";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import { getCurrencyCode } from "../../../../../helpers/CommonHelper";
import parse from "html-react-parser";
import GalleryPictures from "../../../../UI/shared/gallery/GalleryPictures";
const Details = ({ item, detailsDispatch, loadItem, loading }) => {
  const getItems = () => {
    let items = [];

    if (item.categories?.length) {
      items.push({
        text: "Categories",
        value: item.categories.join(", "),
        type: "text",
      });
    }

    if (item.materials?.length) {
      items.push({
        text: "Materials",
        value: item.materials.join(", "),
        type: "text",
      });
    }

    if (item.amazonLink) {
      items.push({
        text: "Amazon Link",
        value: item.amazonLink,
        type: "link",
      });
    }

    if (item.noonLink) {
      items.push({
        text: "Noon Link",
        value: item.noonLink,
        type: "link",
      });
    }

    return items;
  };

  return (
    <>
      <Row>
        <Col>
          <Card className="item  mb-2">
            <Card.Header className="ps-1 pe-2 py-0">
              <Card.Title className="m-0 p-0 " style={{maxWidth:"60%"}}>
                <div className="d-flex ImageSectionSpacing">
                  <div className="ms-1 me-2">
                    <div className=" position-relative  ">
                      <div className="fossilImage">
                        <ReactFancyBox
                          thumbnail={
                            process.env.REACT_APP_BACKEND_URL +
                            "public/" +
                            item.image
                          }
                          image={
                            process.env.REACT_APP_BACKEND_URL +
                            "public/" +
                            item.image
                          }
                          caption={`${item.title}`}
                        />
                      </div>
                      {(item.status === "0" || item.status === 0) && (
                        <i className="fas fa-ban position-absolute ms-1 mb-2 banned2"></i>
                      )}
                    </div>
                  </div>

                  <div className="d-flex flex-column ms-1 mt-1">
                    <span className="m-0 text-bold memberName text-red text-md">
                      {item.title}
                    </span>

                    <span className="">
                      <span className="text-custom-4 mt-1 small  text-bold  text-info mt-1">
                        {item.brand}
                      </span>
                    </span>
                  </div>

                  <div className="position-relative d-inline-block mt-2 ms-3">
                    {item.salePrice && (
                      <h4 className="my-0 text-bold text-primaryCream text-lg" style={{whiteSpace:"nowrap"}}>
                        {item.salePrice} {getCurrencyCode()}
                      </h4>
                    )}

                    {item.price && item.salePrice && (
                      <span
                        className="position-absolute text-muted text-decoration-line-through"
                        style={{
                          top: "-10px",
                          right: "-40px",
                          fontSize: "0.8rem",
                        }}
                      >
                        {item.price} {getCurrencyCode()}
                      </span>
                    )}

                    {!item.salePrice && item.price && (
                      <h4 className="my-0 text-bold text-primaryCream ">
                        {item.price} {getCurrencyCode()}
                      </h4>
                    )}
                  </div>
                </div>
              </Card.Title>

              <div className="card-tools">
                <div className=" text-right  mt-1 mt-xl-2 mt-lg-2 mt-md-2 pt-xl-1 pt-lg-1 pt-md-1 pt-0">
                  {item.showOnHomePage === "1" && (
              <span className="badge badge-pill badge-custom-3 me-1 text-white">
                In Home Page
              </span>
            )}
                  {item.inStock === "1" && (
                    <span className="badge badge-pill badge-custom-7 me-1 text-white">
                      In Stock
                    </span>
                  )}
                  {item.inStock === "0" && (
                    <span className="badge badge-pill  badge-custom-3 me-1 text-white">
                      Out of Stock
                    </span>
                  )}
                  <span className="badge badge-light me-1 text-dark">
                    Status :{" "}
                    <span className="text-secondary">
                      <ModuleDisplayBoolean
                        value={item.status}
                        trueValue="Enabled"
                        falseValue="Disabled"
                      />{" "}
                    </span>
                  </span>
                  {item.createdAt && (
                    <span className="badge badge-light me-1 text-dark">
                      Created Date :{" "}
                      <span className="text-secondary">
                        <ModuleDisplayDate value={item.createdAt} />{" "}
                      </span>
                    </span>
                  )}
                </div>
              </div>
            </Card.Header>

            <Card.Body className="px-2 pt-1 pb-0">
              <Row>
                <Col className="mt-1 mb-1 ">
                  <StatsListing items={getItems()} />
                  {item.description && (
                    <Alert className="alert-custom-3 d-flex mb-1  flex-wrap p-1 font-small">
                      <strong className="me-1 mt-1 text-custom-1">
                        Description:
                      </strong>
                      <div className=" d-flex align-items-center flex-wrap p-1 font-small">
                        <span
                          className="font-small text-normal text-custom-1 html"
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        ></span>
                      </div>
                    </Alert>
                  )}
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <GalleryPictures
            module="products"
            parentId={item._id}
            detailsDispatch={detailsDispatch}
            showAddPictureButton={true}
          />
        </Col>
      </Row>
    </>
  );
};

export default Details;
